import React from 'react';
import { GoMegaphone } from 'react-icons/go';

const Announcement = () => {
  return (
    <span className='flex h-10 bg-black items-center justify-center block uppercase tracking-wide text-white text-xs'>prompthaven.com is in Alpha. <a href="https://forms.gle/FJFoESdXYN73zP9AA" target="_blank" rel="noreferrer" className='ml-1 underline'>Leave a feedback</a></span>
  )
}

{/* <span className='flex h-10 bg-black items-center justify-center block uppercase tracking-wide text-white text-xs'>PROMPTHAVEN is currently in Beta.</span> */}

{/* <div className="bg-slate-900">
<div className="mx-auto max-w-7xl py-2 px-2 sm:px-2 lg:px-4">
  <div className="flex flex-wrap items-center justify-between">
    <div className="flex w-0 flex-1 items-center">
      <span className="flex rounded-lg bg-slate-600 p-2">
      <GoMegaphone className="h-4 w-4 text-white" aria-hidden="true" />
      </span>
      <p className="ml-3 truncate font-medium text-white">
        <span className="md:hidden">prompthaven. is currently in Alpha.</span>
        <span className="hidden md:inline">prompthaven. is currently in Alpha. If you have any suggestions, do leave a feedback! We appreciate your help to improve prompthaven. </span>
      </p>
    </div>

    <div className="order-2 flex-shrink-0 sm:order-3 sm:ml-3">
    <a
        href="#"
        className="flex items-center justify-center rounded-md border border-transparent bg-white px-2 py-2 text-sm font-medium text-slate-600 shadow-sm hover:bg-indigo-50"
      >
        Leave a feedback
      </a>
    </div>
  </div>
</div>
</div> */}

export default Announcement